import React from 'react';
export function Footer() {
  return <footer className="border-t border-border py-8 text-center text-[12px] tracking-[0.04em] text-muted" data-id="element-118">
      <div className="mx-auto max-w-[800px] px-6" data-id="element-119">
        <strong className="font-serif text-gold" data-id="element-120">NEGOCIO DE ORO™</strong>
        <br data-id="element-121" />
        <span className="mt-2 inline-block" data-id="element-122">
          El sistema de joyería N°1 para emprendedores en Argentina.
        </span>
        <br data-id="element-123" />
        <br data-id="element-124" />

        <div className="flex flex-wrap justify-center gap-3" data-id="element-125">
          <span data-id="element-126">contacto@solucionesya.shop</span>
          <span data-id="element-127">·</span>
          <span data-id="element-128">solucionesya.shop</span>
          <span data-id="element-129">·</span>
          <span data-id="element-130">
            © Solucionesya.shop™ 2026 — Todos los derechos reservados.
          </span>
        </div>
      </div>
    </footer>;
}